import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { DataRowComponent } from "../../../_component/pagination-client-side/data-row.component";
import { DictionaryService } from "../../../../dictionary/dictionary.service";

@Component({
  selector: "app-report-config-view",
  templateUrl: "./report-config-view.component.html",
  styleUrls: [
    "./report-config-view.component.scss",
    "./../../../../_styles/ion-grid-content-table.scss",
  ],
})
export class ReportConfigViewComponent implements OnInit, DataRowComponent {
  constructor(public dictionaryService: DictionaryService) {}

  ngOnInit() {}

  @Input()
  row: any;

  @Input()
  displayMobileView = false;

  @Input()
  styleClass;

  @Output()
  refreshRequest: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  actionRequest: EventEmitter<any> = new EventEmitter<any>();
}
